export const SET_WORK_TIME = 'SET_WORK_TIME';
export const SET_WORK_TIME_ID = 'SET_WORK_TIME_ID';
export const UPDATE_CREDIT = 'UPDATE_CREDIT';

export const CHECK_WORK_TIME = 'CHECK_WORK_TIME';
export default {
  SET_WORK_TIME,
  SET_WORK_TIME_ID,
  UPDATE_CREDIT,
  CHECK_WORK_TIME,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutation-types.js